import firebase from "firebase/app"
import "firebase/auth";
import constants from './constants';
import { FirebaseDatabase } from '../account/firebase-database';
import {BaseView} from '../core/view';
import { ApiUtil } from '../utils/api-util';
import {JSErrorTracking} from '../utils/js-error-tracking';
import { StringUtil } from '../utils/string-util';
import {BrowserSupport} from "../utils/browser-support";

const productPreviewTemplate = require('./templates/wishlist-product.hbs');

const selectorWishlistProducts = '.js-wishlist-products';
const selectorWishlistProduct = '.js-wishlist-product';
const selectorNoProducts = '.js-wishlist-no-products';
const selectorLoading = '.js-wishlist-loading';
const selectorWelcome = '.js-welcome-wishlist';

const classNoProductsVisible = 'wishlist__no-products--visible';
const classLoadingHidden = 'wishlist__loading--hidden';
const classWelcomeVisible = 'wishlist__welcome--visible';

const nodeWishlistProducts = document.querySelector(selectorWishlistProducts);
let nodesWishlistProduct;
const nodeNoProducts = document.querySelector(selectorNoProducts);
const nodeLoading = document.querySelector(selectorLoading);
const welcomeWishlist = document.querySelector(selectorWelcome);

const buildProductInfo = function (val) {
    return {
        available: false,
        id: val.productId,
        uuid: val.productUuid,
        previewImageAltText: `${val.brandName} ${val.productName}`,
        brandId: val.brand,
        brandName: val.brandName,
        productName: val.productName,
        priceFormatted: val.priceFormatted,
        soldOut: getI18N(jlocale.soldOut),
        loading: true
    }
};

const getMetaInfo = (product) => {
    if (product.available === true) {
        return product.shippingCostFormatted;
    }
    return getI18N(jlocale.soldOut);
};

const getShopInfo = (product) => {
    if (product.shop !== null) {
        return `${StringUtil.capitalizeFirstLetter(getI18N(jlocale.shopat))} ${product.shop.name}`;
    }
    return '';
};

const requestProducts = function (uuids) {

    function partition(items, size) {
        var result = _.groupBy(items, function(item, i) {
            return Math.floor(i/size);
        });
        return _.values(result);
    }

    const uuidsSlices = partition(uuids, 50); // [[1,2,3], [4,5,6]]

    uuidsSlices.forEach((slice) => {
        ApiUtil.request({
                path: `/apiGetLikedProducts.action?productUuids=${slice.join('&productUuids=')}`,
                success: function (data) {
                    if (data.products !== undefined && data.products.length) {
                        const soldOutText = getI18N(jlocale.soldOut);
                        data.products.forEach((el) => {
                            const div = nodeWishlistProducts.querySelector(`[data-product-like-uuid="${el.uuid}"]`);
                            const data = {
                                available: el.available,
                                id: el.id,
                                url: el.url,
                                uuid: el.uuid,
                                previewImage: el.previewImage,
                                previewImageBlend: el.primaryImage.blend,
                                previewImageCenter: el.primaryImage.center,
                                previewImageBorder: el.primaryImage.border,
                                previewImageMedianColor: el.primaryImage.medianColor,
                                previewImageAltText: `${el.brand.name} ${el.name}`,
                                showSaleAlert: (el.priceSavings > 0),
                                salePercentage: `-${(el.priceSavings * 100).toFixed(0)}%`,
                                brandId: el.brandId,
                                brandName: el.brand.name,
                                productName: el.name,
                                priceFormatted: el.priceFormatted,
                                originalPriceFormatted: el.originalPriceFormatted,
                                shop: el.shop,
                                hasUnitPricing: (el.unitPricingMeasure != null),
                                unitPricingMeasure: el.unitPricingMeasure,
                                hasFreeShipping: el.freeShipping,
                                shippingCost: el.shippingCostFormatted,
                                coLink: el.clickoutLink,
                                loading: false,
                                soldOut: soldOutText,
                                metaInfo: getMetaInfo(el),
                                shopInfo: getShopInfo(el),
                                primaryImageHasBackground: el.primaryImageHasBackground,
                                primaryImageKey: el.primaryImageKey,
                                showVoucher: el.showVoucher,
                                highlight: el.highlight,
                                voucherDisplayName: el.voucherDisplayName,
                                addToWishlistText: getI18N(jlocale.addToWishlist),
                                originalPriceText: getI18N(jlocale.originalPrice),
                                reducedPriceText: getI18N(jlocale.reducedPrice),
                                priceText: getI18N(jlocale.price)
                            };

                            div.outerHTML = productPreviewTemplate(data);
                        });
                    }

                    $('.product-preview--loading').each(function () {
                        $(this).removeClass('product-preview--loading');
                    });
                },
                error: function (xhr) {
                    JSErrorTracking.sendCustomError(`Personal product scrollable failed: ${xhr.status}`);
                }
            });

    });


};

const getSortedLikes = (likes) => _.sortBy(_.values(likes), 'dateCreated').reverse();

const printWishlist = (uuids, htmlMarkup, wishlistElem) => {
    if (uuids.length > 0) {
        nodeWishlistProducts.innerHTML = htmlMarkup;
        wishlistElem.classList.add('has-items');
        requestProducts(uuids);
    } else {
        nodeNoProducts.classList.add(classNoProductsVisible);
    }
    
    nodeLoading.classList.add(classLoadingHidden);
};

const showNoProductsTextIfWishlistGetsEmpty = () => {
    // this has to get queried freshly every time the function gets called.
    nodesWishlistProduct = document.querySelectorAll(selectorWishlistProduct);
    if (nodesWishlistProduct.length === 0) {
        nodeNoProducts.classList.add(classNoProductsVisible);
    }
};

export default BaseView.extend({

    initialize: function () {
        let self = this;

        if (BrowserSupport.isLocalStorageSupportedAndActive()) {
            if(sessionStorage.getItem('justSignedUp') === "1"){
                welcomeWishlist.classList.add(classWelcomeVisible);
            }
            sessionStorage.setItem('justSignedUp', '0');
        }

        if (nodeWishlistProducts !== null) {
            let htmlMarkup = '';
            let uuids = [];
            // Authentication flag to make sure that the `onAuthStateChanged`
            // call (and thus the `getUserLikes` call) doesn't get called
            // twice.
            let authFlag = false;

            //get likes from firebase or local wishlist
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    FirebaseDatabase
                        .getUserLikes(user.uid)
                        .then((likes) => {
                            if (authFlag === true) {
                                return;
                            }
                            
                             // add uuid from key to likes for later use
                             _.each(likes, function(value, key, obj) { 
                                   value['productUuid'] = key;
                                   obj[key] = value;
                                }); 
    
                            for (const like of getSortedLikes(likes)) {
                                   uuids.push(like.productUuid);
                                htmlMarkup += productPreviewTemplate(buildProductInfo(like));
                            }
                            printWishlist(uuids, htmlMarkup, self.el);
                            authFlag = true;
                        });
                } else {
                    nodeLoading.classList.add(classLoadingHidden);
                    showNoProductsTextIfWishlistGetsEmpty();
                }
            });

            document.addEventListener(
                constants.EVENT_ITEM_REMOVED_FROM_WISHLIST_PAGE,
                showNoProductsTextIfWishlistGetsEmpty,
                false
            );
        }
    }
});
